<template>
        <div class="row left ch pointer click" style="margin-bottom: 6px;">
            <CheckIcon :status="status"/>
            <span class="itemText"><slot></slot></span>
        </div>          
</template>

<script setup>
import CheckIcon from './CheckIcon.vue';
</script>
<script>

/*
    <SmallCheckItem status="done">Permit</SmallCheckItem>
*/


export default {
    data: function () {return {
         value: this.active,
    }},
    props:{        
        status: String,
    },       
}
</script>

<style scoped>
   .itemText{
    font-family: Roboto, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
    font-size: 13px; 
    margin-left: 8px;
    margin-bottom: 1px;
    color: var(--g6);
    letter-spacing: 1%;    
   }
   /* .itemText:hover{
    color: var(--g6);
   } */

</style>

